import React, { useEffect, useState } from "react";
import ConsultationList from "../../ui/doctor/ConsultationList"; // Component to display the list of consultations

import { Box, Typography, Button } from "@mui/material"; // Material UI components
import CallIcon from "@mui/icons-material/Call"; // Icon for the booking button
import EventNoteIcon from "@mui/icons-material/EventNote"; // Empty state icon

import { useNavigate } from "react-router-dom";
import DoctorTimeSlotBooking from "./Fsn8DoctorTimeSlotBooking";
import PWAHeader from "../../common/PWAHeader";
import AppNavigation from "../../navigation/AppNavigation"; // Import AppNavigation
import FsnDoctorTimeSlotBooking from "./Fsn8DoctorTimeSlotBooking";
import Fsn8DoctorTimeSlotBooking from "./Fsn8DoctorTimeSlotBooking";
import PrimaryButton from "../../common/PrimaryButton";
import LoadingScreenBlackLogo from "../../common/LoadingProgressBar";
import { fetchPlayerDoctorAppointments } from "../../apiservices/ApiService";

function Fsn11DoctorConsultation({ onTap }) {
  const navigate = useNavigate(); // React Router navigation hook
  const { handleNavigation } = AppNavigation(); // Navigation handler from AppNavigation

  // State management
  const [data, setData] = useState({ appointments: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState("home");
  const [selectedAppointmentData, setSelectedAppointmentData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true); // Show loading screen
      try {
        const response = await fetchPlayerDoctorAppointments();
        if (response) {
          setData(response || { appointments: [] }); // Populate data
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false); // Hide loading screen
      }
    };
    fetchData(); // Fetch appointments on component load
  }, []);

  const handleBookConsult = () => {
    const onTapData = {
      NavigationType: "3",
      FSN: "8", // Updated FSN value
      FSSN: "0",
      FAI: { ...data }, // Include the full data
    };

    console.log("Navigating with onTap data:", onTapData);

    handleNavigation(onTapData); // Use handleNavigation to navigate
  };

  return (
    <>
      {/* Header Section */}
      <PWAHeader title={onTap?.FAI?.title || "Doctor Consults"} />

      {/* Loading State */}
      {isLoading && <LoadingScreenBlackLogo />}

      {/* Main Content */}
      {!isLoading && (
        <div>
          <div style={{ padding: "16px", position: "relative", minHeight: "100vh", backgroundColor: "rgba(255, 152, 0, 0.11)", color: "#771615" }}>
            {data.appointments.length > 0 ? (
              <>
                {/* Banner */}
                <img
                  src={"https://appcdn.goqii.com/storeimg/72738_1739863930.png"}
                  alt={data.title || "Banner"}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    display: "block",
                    marginBottom: "20px",
                  }}
                />
                {/* Appointments List */}
                <ConsultationList appointments={data.appointments} />
              </>
            ) : (
              // Empty State
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "70vh",
                  textAlign: "center",
                }}
              >
                <EventNoteIcon sx={{ fontSize: "80px", color: "gray", marginBottom: "16px" }} />
                <Typography variant="h6" sx={{ marginBottom: "8px" }}>
                  No Appointments Yet
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ marginBottom: "24px" }}>
                  You currently have no appointments with a GOQii Doctor.
                  <br />
                  Click below to book your first consultation.
                </Typography>
              </Box>
            )}
          </div>

          {/* Floating Button */}
          <div
            style={{
              position: "fixed",
              bottom: "15px",
              right: "15px",
              zIndex: 1000,
            }}
          >


            {/* Log Button */}
            {/* <PrimaryButton  startIcon={<CallIcon />} onClick={handleBookConsult} label="Book" /> */}
            {/* <Button
              variant="contained"
              // color="primary"
              onClick={handleBookConsult}
              startIcon={<CallIcon />}
              sx={{
                borderRadius: "50px",
                padding: "12px 24px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                background: "linear-gradient(90deg, #771615 0%, #FF9800 100%)",
                scale: "0.9",
              }}
            >
              Book a Doctor Consult
            </Button> */}

            <PrimaryButton onClick={handleBookConsult} startIcon={<CallIcon />} label={'Book a Doctor Consult'} sx={{ p: "12px 24px" }} />
          </div>
        </div>
      )}

    </>
  );
}

export default Fsn11DoctorConsultation;